/* Better Body: additive media controls. Existing gallery/variant/zoom handlers remain owners of state. */
(() => {
  if (window.bbMediaControlsLoaded) return;
  window.bbMediaControlsLoaded = true;
  const icon = direction => `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="${direction < 0 ? 'm14 6-6 6 6 6' : 'm10 6 6 6-6 6'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const playIcon = '<svg viewBox="0 0 10 14" aria-hidden="true" focusable="false"><path d="M1.48177 .814643C.81532 .448245 0 .930414 0 1.69094V12.2081C0 12.991 .858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 .814643Z" fill="currentColor"/></svg>';
  const videoSelector = '[class*="__video-play"],.bb-clothing-video-toggle,.wr-video-play,[data-video-play],.bb-video-play';
  function videos(scope) {
    scope.querySelectorAll(videoSelector).forEach(button => {
      if (button.dataset.bbMediaReady || !button.matches('button')) return;
      const card = button.parentElement;
      const video = card.querySelector('video');
      if (!video) return; // Leave pending/unconfigured video slots alone.
      button.dataset.bbMediaReady = 'true';
      button.classList.add('bb-media-play');
      card.classList.add('bb-media-video');
      const originalLabel = (button.getAttribute('aria-label') || 'Play video').replace(/^Pause/i, 'Play');
      const pause = document.createElement('button');
      pause.type = 'button';
      pause.className = 'bb-media-pause';
      pause.setAttribute('aria-label', originalLabel.replace(/^Play/i, 'Pause'));
      pause.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M6 4h4v16H6zm8 0h4v16h-4z"/></svg>';
      pause.hidden = true;
      card.append(pause);
      pause.addEventListener('click', event => { event.stopPropagation(); video.pause(); });
      const sync = () => {
        const playing = !video.paused && !video.ended;
        const restoreFocus = !playing && document.activeElement === pause;
        button.classList.toggle('bb-media-playing', playing);
        button.setAttribute('aria-label', originalLabel);
        button.innerHTML = '<span aria-hidden="true">' + playIcon + '</span>';
        pause.hidden = !playing;
        if (playing && document.activeElement === button) pause.focus({ preventScroll: true });
        if (restoreFocus) button.focus({ preventScroll: true });
      };
      ['play', 'playing', 'pause', 'ended', 'error', 'emptied'].forEach(event => video.addEventListener(event, () => queueMicrotask(sync)));
      sync();
    });
  }
  // [thumbnail strip, media viewport, existing navigation]. A viewport can contain multiple slides.
  const maps = [
    ['.bb-gl__thumbs', '.bb-gl__hero'], ['.bb-iw__thumbs', '.bb-iw__hero'],
    ['.bb-patchwork__thumbs', '.bb-patchwork__hero'], ['.bb-sculpt__thumbs', '.bb-sculpt__hero'],
    ['.bb-xr__thumbs', '.bb-xr__hero'], ['.bb-cs__thumbs', '.bb-cs__hero'],
    ['.bb-clothing-thumbs', '.bb-clothing-main'], ['.bb-reference-thumbs', '.bb-reference-main-image'],
    ['.bb-knee-thumbs', '.bb-knee-main'], ['.bb-bra-draft__thumbs', '.bb-bra-draft__image'],
    ['.bb-pulse__thumbs', '.bb-pulse__slides'], ['.bb-debloat__thumbs', '.bb-debloat__slides'],
    ['.bb-media-thumbs', '.bb-media-frame'], ['.bb-mag-thumbs', '.bb-mag-slides', '[data-mag-prev],[data-mag-next]'],
    ['.d3-thumbs', '.d3-main-image', '.d3-gallery-nav button'], ['.dw-thumbs', '.dw-stage'],
    ['.bbs2-thumbs', '.bbs2-stage', '[data-gallery-prev],[data-gallery-next]'],
    ['.crj__thumbs', '.crj__hero-wrap', '.crj__arrow'],
    ['.bb-fragrance__thumbs', '[data-main-image]', '[data-step]'],
    ['.bb-sculpt__gallery-thumbs', '.bb-sculpt__gallery-track', '[data-gallery-step]'],
    ['.cs-gallery-thumbs', '.cs-gallery-track', '[data-cs-gallery-step]'],
    ['.bb-fleece__thumbs', '.bb-fleece__gallery-main', '.bb-fleece__gallery-arrow'],
    ['.wr-thumbs', '.wr-hero-wrap', '.wr-gallery-arrow'],
    ['.bb-led-page__thumbs', '.bb-led-page__main-image'],
    ['.bb-led-page__upsell-thumbs', '.bb-led-page__upsell-main']
  ];
  const selected = '[aria-pressed="true"],[aria-current="true"],[aria-selected="true"],.is-active,.is-current,.is-selected';
  const eligible = button => !button.hidden && !button.closest('[hidden],.hidden');
  function addControls(root, stage, getItems, getIndex, select, oldControls) {
    root.classList.add('bb-media-gallery');
    const overlay = document.createElement('div');
    overlay.className = 'bb-media-arrows';
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'bb-media-arrow';
      button.setAttribute('aria-label', direction < 0 ? 'Previous product image' : 'Next product image');
      button.innerHTML = icon(direction);
      button.addEventListener('click', () => {
        const items = getItems(); if (items.length < 2) return;
        const index = getIndex(items);
        select(items[(Math.max(0, index) + direction + items.length) % items.length]);
        requestAnimationFrame(update);
      });
      overlay.append(button); return button;
    });
    root.append(overlay);
    function update() {
      const items = getItems();
      overlay.hidden = items.length < 2;
      buttons.forEach(button => { button.disabled = items.length < 2; });
      const visibleStage = typeof stage === 'function' ? stage() : stage;
      if (!visibleStage) { overlay.hidden = true; return; }
      const frame = visibleStage.closest('.bb-bodysuit-hero-frame') || visibleStage;
      const container = overlay.offsetParent || root;
      const rect = frame.getBoundingClientRect(), parent = container.getBoundingClientRect();
      overlay.style.top = `${rect.top - parent.top + container.scrollTop}px`;
      overlay.style.left = `${rect.left - parent.left + container.scrollLeft}px`;
      overlay.style.width = `${rect.width}px`; overlay.style.height = `${rect.height}px`;
      if (oldControls) root.querySelectorAll(oldControls).forEach(button => { if (!button.classList.contains('bb-media-old-arrow')) button.classList.add('bb-media-old-arrow'); });
    }
    const observer = new MutationObserver(mutations => {
      if (mutations.some(m => !overlay.contains(m.target) && m.target !== overlay)) requestAnimationFrame(update);
    });
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'aria-pressed', 'aria-current', 'aria-selected', 'src', 'class'] });
    const resize = new ResizeObserver(update); resize.observe(root);
    const initialStage = typeof stage === 'function' ? stage() : stage;
    if (initialStage) resize.observe(initialStage);
    root.addEventListener('load', update, true);
    const unload = event => {
      if (!event.target.contains(root)) return;
      observer.disconnect(); resize.disconnect();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    // Native buttons provide Enter/Space. Left/Right are also available while an arrow is focused.
    overlay.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault(); event.stopPropagation(); buttons[event.key === 'ArrowLeft' ? 0 : 1].click();
    });
    update();
  }
  function customGalleries(scope) {
    maps.forEach(([stripSelector, stageSelector, oldControls]) => {
      scope.querySelectorAll(stripSelector).forEach(strip => {
        if (strip.dataset.bbMediaReady) return;
        let root = strip.parentElement;
        // A few existing controls nest the thumbnail strip one level below its viewport.
        while (root && !root.querySelector(stageSelector) && !root.classList.contains('shopify-section')) root = root.parentElement;
        if (!root || !root.querySelector(stageSelector)) return;
        strip.dataset.bbMediaReady = 'true';
        let last = 0;
        const getItems = () => [...strip.querySelectorAll('button')].filter(eligible);
        strip.addEventListener('click', event => { const index = getItems().indexOf(event.target.closest('button')); if (index >= 0) last = index; });
        const stage = () => [...root.querySelectorAll(stageSelector)].find(el => !el.hidden && getComputedStyle(el).display !== 'none');
        addControls(root, stage, getItems, items => {
          const viewport = stage();
          // Scroll galleries retain their native swipe/keyboard state even between thumbnail updates.
          if (viewport && viewport.scrollWidth > viewport.clientWidth + 10 && /track/.test(viewport.className)) {
            const slides = [...viewport.children];
            return slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - viewport.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - viewport.scrollLeft) ? i : best, 0);
          }
          const current = items.findIndex(button => button.matches(selected));
          return current >= 0 ? current : Math.min(last, items.length - 1);
        }, item => item.click(), oldControls);
      });
    });
  }
  function sharedGalleries(scope) {
    scope.querySelectorAll('media-gallery').forEach(gallery => {
      if (gallery.dataset.bbMediaReady) return;
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer) return;
      gallery.dataset.bbMediaReady = 'true';
      const items = () => [...viewer.querySelectorAll('.product__media-item[data-media-id]')].filter(item => !item.hidden && !item.classList.contains('hidden') && (!item.classList.contains('product__media-item--variant') || item.classList.contains('is-active') || item.offsetWidth > 0));
      const stage = () => {
        const slider = viewer.querySelector('[id^="Slider-Gallery"]');
        if (slider && slider.scrollWidth > slider.clientWidth + 10) return slider;
        return viewer.querySelector('.product__media-item.is-active') || items()[0];
      };
      addControls(viewer, stage, items, slides => {
        const slider = viewer.querySelector('[id^="Slider-Gallery"]');
        if (slider && slider.scrollWidth > slider.clientWidth + 10) return slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - slider.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - slider.scrollLeft) ? i : best, 0);
        return slides.findIndex(slide => slide.classList.contains('is-active'));
      }, item => {
        if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(item.dataset.mediaId, false);
      }, '.slider-buttons > .slider-button--prev,.slider-buttons > .slider-button--next');
    });
  }
  function init(scope = document) { videos(scope); customGalleries(scope); sharedGalleries(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => queueMicrotask(() => init(event.target)));
})();
